import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    diagnostico: [],
  },

  getters: {
    getDiagnostico: (state) => state.diagnostico,
  },

  mutations: {
    SET_DIAGNOSTICO(state, diagnostico) {
      state.diagnostico = diagnostico;
    },
  },

  actions: {
    async fetchDiagnostico({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catdiagnostico')
        .then((response) => {
          commit('SET_DIAGNOSTICO', response.data.data);
        });
    },
  },
};
